"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return getSwaggerJSON;
    }
});
const _swaggerUtils = require("../shared/swaggerUtils");
const _swaggerbasejson = /*#__PURE__*/ _interop_require_default(require("./swagger-base.json"));
const _getPaths = /*#__PURE__*/ _interop_require_default(require("./getPaths"));
const _getSchemas = /*#__PURE__*/ _interop_require_default(require("./getSchemas"));
const _getSwaggerColumnMetas = /*#__PURE__*/ _interop_require_default(require("./getSwaggerColumnMetas"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
async function getSwaggerJSON(context, { base, sourcesMap, models }, ncMeta = _Noco.default.ncMeta) {
    return (0, _swaggerUtils.generateSwagger)({
        context,
        base,
        models,
        sourcesMap,
        ncMeta
    }, _swaggerbasejson.default, _getSwaggerColumnMetas.default, _getPaths.default, _getSchemas.default);
}
